
import { ReactElement } from "react";

export interface SubNavItem {
  title: string;
  href: string;
  description: string;
}

export interface NavItem {
  title: string;
  href: string;
  icon: React.ElementType;
  description: string;
  subItems?: SubNavItem[];
}

// Navigation items with nested subitems
export const navItems: NavItem[] = [
  {
    title: "Dashboard",
    href: "/dashboard",
    icon: Home,
    description: "Overview of your plant care services"
  },
  {
    title: "Appointments",
    href: "/schedule",
    icon: Calendar,
    description: "Manage your upcoming plant care visits",
    subItems: [
      {
        title: "Book New Visit",
        href: "/booking",
        description: "Schedule a new plant care visit"
      },
      {
        title: "Upcoming Visits",
        href: "/schedule",
        description: "View your scheduled visits"
      }
    ]
  },
  {
    title: "History",
    href: "/dashboard/history",
    icon: Clock,
    description: "View your past plant care visits"
  },
  {
    title: "Analytics",
    href: "/dashboard/analytics",
    icon: ChartBar,
    description: "Track and analyze your plant care data"
  },
  {
    title: "Account",
    href: "#",
    icon: UserCircle,
    description: "Manage your account settings",
    subItems: [
      {
        title: "Profile",
        href: "/profile",
        description: "Update your personal information"
      },
      {
        title: "Payment Methods",
        href: "/dashboard/payment",
        description: "Manage your payment information"
      },
      {
        title: "Preferences",
        href: "/dashboard/preferences",
        description: "Customize your plant care experience"
      }
    ]
  }
];

import { 
  Calendar, 
  Clock, 
  ChartBar, 
  Home, 
  UserCircle 
} from "lucide-react";
